import axios from "../_helpers/axiosInstance.js";
import {authHeader} from "../_helpers/authHeader.js";

const getTaxAuthorities = async () => {
    var response = await axios.get(`taxAuthority`, {headers: authHeader()})
    return response.data.result;
}

const getTaxAuthorityStatus = async () => {
    var response = await axios.get(`taxAuthority/status`, {headers: authHeader()});
    return response.data.result;
}

const getCurrentOutageStatus = async () => {
    const response = await axios.get(`taxAuthority/outage-status`, {headers: authHeader()});
    return response.data.result;
};

const getTaxAuthInfo = async (taxAuthId) => {
    var response = await axios.get(`taxAuthority/${taxAuthId}`, {headers: authHeader()});
    return response.data.result;
}

const updateTaxAuth = async (taxAuthId, payload) => {
    await axios.put(`taxAuthority/${taxAuthId}`, payload, {headers: authHeader()});
};

const getTaxAuthUsers = async (taxAuthId) => {
    const response = await axios.get(`taxAuthority/${taxAuthId}/users`, {headers: authHeader()});
    return response.data.result;
};

const inviteTaxAuthUser = async (taxAuthId, payload) => {
    await axios.post(`taxAuthority/${taxAuthId}/users/invite`, payload, {headers: authHeader()});
};

const inviteTaxAuth = async (taxAuthorityName, taxAuthCode, inviteeFirstName, inviteeLastName, inviteEmailAddress, stripeBusinessType) => {
    const data = {  taxAuthorityName, taxAuthCode, inviteeFirstName, inviteeLastName, inviteEmailAddress, stripeBusinessType};
    await axios.post('taxAuthority/invite', data, {headers: authHeader()});
}

const getOnboardingInfo = async (inviteKey) => {
    let response = await axios.get(`taxAuthority/invite/${inviteKey}/info`);
    return response.data.result;
}

const getRecentOrders = async () =>{
    let response = await axios.get(`/taxAuthorityOrder/recent`,  {headers: authHeader()})
    return response.data.result;
}

export const taxAuthApi = {
    inviteTaxAuth, getOnboardingInfo,getTaxAuthorities, getRecentOrders, getTaxAuthInfo, getTaxAuthorityStatus, getCurrentOutageStatus, updateTaxAuth, getTaxAuthUsers, inviteTaxAuthUser
}
